export default __webpack_public_path__ + "static/media/talk-through-illustration.f949cc71.png";